//window contains information about the window url
//It checks whether this is local development aka "localhost" if so the variable is set the local node server
//If the window is not the local development it will switch to the google cloud run service
const API_URL =
  window.location.hostname === 'localhost'
    ? 'http://localhost:3000'
    : 'https://pixelstoplayers-134410011176.northamerica-northeast2.run.app';

export default API_URL;



// WEBPACK FOOTER //
// ./src/api/config.js